import { createSelector } from '@ngrx/store';

import {
  BillOfMaterialsState,
  DetailState,
  SchaefflerBillOfMaterialsState,
  VitescoBillOfMaterialsState,
} from '@cdba/core/store/reducers/detail/detail.reducer';
import { BillOfMaterialsType } from '@cdba/shared/constants';

import { selectDetailState } from '../../../reducers';

export const selectBillOfMaterialsState = createSelector(
  selectDetailState,
  (state: DetailState): BillOfMaterialsState => state.billOfMaterials
);

export const selectBillOfMaterialsLoading = createSelector(
  selectBillOfMaterialsState,
  (state: BillOfMaterialsState): boolean => state?.loading
);

export const selectBillOfMaterialsError = createSelector(
  selectBillOfMaterialsState,
  (state: BillOfMaterialsState): string => state?.errorMessage
);

export const selectBillOfMaterialsType = createSelector(
  selectBillOfMaterialsState,
  (state: BillOfMaterialsState): BillOfMaterialsType => state?.type
);

export const selectBillOfMaterialsSelectedItemRowId = createSelector(
  selectBillOfMaterialsState,
  (state: BillOfMaterialsState): string => state?.selectedItemRowId
);

export const isSchaefflerBillOfMaterialGuard = (
  billOfMaterials: BillOfMaterialsState
): billOfMaterials is SchaefflerBillOfMaterialsState =>
  billOfMaterials.type === BillOfMaterialsType.SCHAEFFLER;

export const isVitescoBillOfMaterialGuard = (
  billOfMaterials: BillOfMaterialsState
): billOfMaterials is VitescoBillOfMaterialsState =>
  billOfMaterials.type === BillOfMaterialsType.VITESCO;
